import { render, staticRenderFns } from "./packagings.vue?vue&type=template&id=1566b6f6&scoped=true"
import script from "./packagings.vue?vue&type=script&lang=js"
export * from "./packagings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1566b6f6",
  null
  
)

export default component.exports